import { DatesValues } from '@p81-common/ui';
import { periodFormat, toQueryParams } from 'utils/common';
import {
  CLOUD_MANAGEMENT_LOGS_URL_PREFIX,
  defaultFilters
} from './configurates';

export const createLinkForRequest = (filter: Record<string, unknown>) => {
  return filter
    ? `${CLOUD_MANAGEMENT_LOGS_URL_PREFIX}?filter=${toQueryParams({
        ...defaultFilters,
        ...filter
      })}`
    : CLOUD_MANAGEMENT_LOGS_URL_PREFIX;
};

export const createReqBody = (filter = defaultFilters) => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      action: filter.action?.[0] ? filter.action : '*',
      status: filter.status?.[0] ? filter.status : '*',
      datetime: periodFormat(validateDatesValues(filter.datetime)),
      networkVersion: filter.networkVersion?.[0] ? filter.networkVersion : '*',
      'entities.gatewayImageVersion': filter['entities.gatewayImageVersion'][0]
        ? filter['entities.gatewayImageVersion']
        : '*',
      batchId: filter.batchId?.[0] ? filter.batchId : '*',
      updatedByName: filter.updatedByName?.[0] ? filter.updatedByName : '*',
      isTestTenant: filter.isTestTenant ? filter.isTestTenant : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};

export const validateDatesValues = (fieldValue?: DatesValues) =>
  Array.isArray(fieldValue) ? { startDate: null, endDate: null } : fieldValue;
